export const REDIRECT_ORIGIN_PARAM = 'REDIRECTED_USER'
